// Animates its children from the scene clock (or a local clock in previews).
import React, { useRef } from "react";
import { applyStyle, stagePxScale, styleAt } from "./animationEngine.es6";
import { useAnimationSampler } from "./useAnimationSampler";

/* eslint-disable react/prop-types */
export function AnimatedWrapper({
  children,
  initial,
  animateTarget,
  transition = {},
  style = {},
  isPaused = false,
  seekTimeSec = null,
  timeOriginSec = null,
  sceneId = null,
  clearBeforeStart = false,
  // Time at which an exit takes over this entry.
  releaseAtSec = null,
  as = "div",
  active = true,
}) {
  const ref = useRef(null);
  useAnimationSampler(
    ref,
    (el, t) => {
      const dormant = !active && seekTimeSec == null && timeOriginSec == null;
      const released = releaseAtSec != null && t >= releaseAtSec;
      if (dormant || released || (clearBeforeStart && t < 0)) {
        el.style.transform = style.transform || "";
        el.style.opacity = style.opacity ?? "";
        el.style.clipPath = style.clipPath || "";
        el.style.width = style.width || "";
        return;
      }
      applyStyle(
        el,
        styleAt({ initial, animate: animateTarget, transition }, Math.max(0, t), stagePxScale(el))
      );
    },
    { seekTimeSec, timeOriginSec, sceneId, isPaused, active }
  );
  const Tag = as === "span" ? "span" : "div";
  return (
    <Tag ref={ref} style={style}>
      {children}
    </Tag>
  );
}
export default AnimatedWrapper;
